import { Type } from 'class-transformer';
import { PaymentRequestRawDto } from './payment-request-raw-dto';

export class AddPaymentRequestParameterDto {
    @Type(() => PaymentRequestRawDto)
    paymentRequest: PaymentRequestRawDto;

    workOrderIds: Array<number>;
}
